import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';

// Column
import { AnnoucmentColumns, NoticeColumns } from '../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate, ActiveInactiveOptions } from '../../appconfig/Settings';

//Services
import { deleteDataWithMultipleParameters, getAllDetails, postAllData } from '../../service/ProductService';

import { pdfTemplate } from '../../appconfig/DatatableTemplateSetting';

// Api
import { ADD_LATEST_UPDATE, ADD_NOTICE, DELETE_LATEST_UPDATE, DELETE_NOTICE, GET_LATEST_UPDATE, GET_NOTICE, LATEST_UPDATE_STATUS, NOTICE_STATUS } from '../../config/ApiConstant';
import { addUpdateNoticeValidate } from '../../config/Validate';
import { FrontWebsiteTabs } from './FrontWebsiteTab';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';

export const LatestUpdate = () => {
    document.title = 'Announcement & Notifications | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [announcementList, setAnnouncementList] = useState<any>([]);
    const [editId, setEditId] = useState<any>(null);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [openApproveModal, setOpenApproveModal] = useState<boolean>(false);
    const [approveId, setApproveId] = useState<any>(null);
    const [approveVal, setApproveVal] = useState<any>(null);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [approveLoading, setApproveLoading] = useState<boolean>(false);
    const [noticeDetails, setNoticeDetails] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });

    // use effect method
    useEffect(() => {
        getAllAnnouncementData();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get college list api call
    const getAllAnnouncementData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_LATEST_UPDATE);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setAnnouncementList([]);
                } else {
                    setAnnouncementList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setAnnouncementList([]);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(false);
                setAnnouncementList([]);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
        getAllAnnouncementData();
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button label="Add Announcement & Notifications" icon="pi pi-plus" className="p-button mr-2" onClick={() => openAddModal()} />
            </>
        );
    };

    //clear button
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary mr-2"></Button>
            </>
        );
    };

    // Template for action body
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions">
                    <Button icon="pi pi-eye" tooltip="View" tooltipOptions={{ position: 'top' }} className="p-button-rounded mr-2" onClick={() => linkOpen(rowData?.latest_update_file)} />
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData.id)} />
                </div>
            </>
        );
    };

    //status Template
    const statusTemplate = (rowData: any) => {
        return (
            <>
                <InputSwitch checked={rowData?.status === 1 ? true : false} onChange={(e) => openApprove(e.value, rowData.id)} defaultChecked={rowData.status === 1 ? true : false} />
            </>
        );
    };

    //Open Link in new tab
    const linkOpen = (file: any) => {
        window.open(file, '_blank');
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setNoticeDetails({});
        setErrors({});
        setEditId(null);
        setSubmitLoading(false);
        setAddUpdateModal(false);
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData?.id);

        const fileName = rowData.latest_update_file.split('/').pop();
        const fileType = `${fileName.split('.').pop()}`;
        // Create the desired object
        const FileObject = {
            url: rowData.latest_update_file,
            name: fileName,
            type: fileType
        };
        setNoticeDetails({
            notice_title: rowData?.latest_update_title,
            notice_file: FileObject
        });
        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setSubmitLoading(false);
        setDeleteModal(false);
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'notice_file') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || '';
        }
        setNoticeDetails({ ...noticeDetails, [name]: val });
    };

    // On submit add update college
    const onSubmitAddUpdateCollege = async () => {
        try {
            const { errors, isError } = addUpdateNoticeValidate(noticeDetails);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                //Request object
                let formData: any = new FormData();

                // Check editing is performed or not

                if (editId !== null) {
                    formData.append('id', editId);

                    if (noticeDetails?.notice_file && noticeDetails?.notice_file?.name && !noticeDetails?.notice_file?.url) {
                        formData.append('latest_update_file', noticeDetails?.notice_file);
                    }
                } else {
                    // Check for image if uploaded or not
                    if (!window.cn(noticeDetails) && !window.cn(noticeDetails.notice_file)) {
                        formData.append('latest_update_file', noticeDetails?.notice_file);
                    }
                }

                formData.append('latest_update_title', noticeDetails?.notice_title);

                //apicall
                const response = await postAllData(ADD_LATEST_UPDATE, formData);
                if (response && !window.cn(response)) {
                    setEditId(null);
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    closeAddUpdateModal();
                    setTimeout(() => {
                        getAllAnnouncementData();
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                const backendErrors = error.response.data.errors;

                if (backendErrors) {
                    // Map backend errors to your state
                    const formattedErrors: any = {};

                    Object.keys(backendErrors).forEach((key) => {
                        formattedErrors[key] = backendErrors[key].join(' '); // Convert array messages into a single string
                    });
                    setErrors(formattedErrors);
                    setSubmitLoading(false);

                    toast.current?.show({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: 'Please fix the errors and try again.'
                    });
                } else {
                    //Spinner False and Set Toast

                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error || 'Something went wrong!' });
                }
            }
        }
    };

    // Delete college api call
    const deleteCollegeApiCall = async () => {
        try {
            setSubmitLoading(true);
            // Delete api call
            const response = await deleteDataWithMultipleParameters(DELETE_LATEST_UPDATE + '?id=' + deleteId);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setSubmitLoading(false);
                setDeleteModal(false);
                setDeleteId(null);
                getAllAnnouncementData();
                setPageLoad(true);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setSubmitLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setSubmitLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    //delete selected file
    const onFileDelete = (name: string) => {
        setNoticeDetails({ ...noticeDetails, [name]: '' });
    };

    //Open Approve Modal
    const openApprove = (val: any, id: any) => {
        setOpenApproveModal(true);
        setApproveId(id);

        if (val === true) {
            setApproveVal(1);
        } else {
            setApproveVal(0);
        }
    };
    //close Approve Modal
    const closeApproveModal = () => {
        setOpenApproveModal(false);
        setApproveId(null);
        setApproveVal(null);
    };

    //status chnage api
    const approveStatusChange = async () => {
        try {
            setApproveLoading(true);

            const requestData = {
                id: approveId,
                status: approveVal
            };

            const response = await postAllData(LATEST_UPDATE_STATUS, requestData);
            if (response) {
                setApproveLoading(false);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                closeApproveModal();
                getAllAnnouncementData();
            }
        } catch (error: any) {
            if (error.response) {
                setApproveLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error || 'Something went wrong!' });
            }
        }
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={ActiveInactiveOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    return (
        <>
            <FrontWebsiteTabs mainTabLabel="Announcement & Notifications" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={announcementList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={announcementList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Announcemnt & Notifications Found"
                                    removableSort
                                >
                                    {AnnoucmentColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'latest_update_file') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={pdfTemplate} />;
                                        } else if (col.field === 'status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '3rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AnnoucmentColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '500px' }}
                header={editId !== null ? 'Edit Announcement & Notifications' : 'Add Announcement & Notifications'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" className="p-button-primary" icon="pi pi-check" onClick={() => onSubmitAddUpdateCollege()} loading={submitLoading} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">
                            Announcement & Notifications Title
                            <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText
                            value={noticeDetails?.notice_title}
                            name="notice_title"
                            autoComplete="off"
                            placeholder="Enter Announcement & Notifications Title"
                            onChange={(e) => onInputChange(e, 'notice_title')}
                            className={errors['notice_title'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['notice_title']}</small>
                    </div>

                    <div className="field col-12">
                        <label htmlFor="name">Notice File </label>
                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i>
                            <span>Upload Notice File</span>
                            <input type="file" id="fileInput" accept="application/pdf" onChange={(e) => onInputChange(e, 'notice_file')} className="file-input" />
                        </div>

                        {window.cn(editId) && !window.cn(noticeDetails?.notice_file) && (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={URL.createObjectURL(noticeDetails?.notice_file)} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {noticeDetails?.notice_file.name}
                                    </a>
                                    <span className="file-details">
                                        {noticeDetails?.notice_file.type} &nbsp;♦&nbsp; {(noticeDetails?.notice_file.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                                <i className="pi pi-trash file-delete" onClick={() => onFileDelete('notice_file')} title="Delete"></i>
                            </div>
                        )}

                        {!window.cn(editId) && !window.cn(noticeDetails)
                            ? (!window.cn(noticeDetails?.notice_file) || noticeDetails?.notice_file?.name) && (
                                  <>
                                      <div className="file-preview">
                                          <div className="file-info">
                                              <a href={!window.cn(noticeDetails?.notice_file) ? noticeDetails?.notice_file?.url : URL.createObjectURL(noticeDetails?.notice_file?.url)} target="_blank" rel="noopener noreferrer" className="file-name">
                                                  {noticeDetails?.notice_file?.name}
                                              </a>
                                              <span className="file-details">
                                                  {noticeDetails?.notice_file.type} &nbsp;&nbsp; {!window.cn(noticeDetails?.notice_file.size) && (noticeDetails?.notice_file.size / 1024).toFixed(2) + ' ' + 'KB'}
                                              </span>
                                          </div>
                                      </div>
                                  </>
                              )
                            : ''}
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Announcement & Notification"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteCollegeApiCall} loading={submitLoading} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Announcement & Notification, This will be deleted permanently.</span>
                </div>
            </Dialog>

            {/* Status Change Dialog */}
            <Dialog
                visible={openApproveModal}
                style={{ width: '450px' }}
                header="Approve Announcement & Notification"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeApproveModal} />
                        <Button label="Submit" icon="pi pi-check" onClick={() => approveStatusChange()} loading={approveLoading} />
                    </>
                }
                onHide={closeApproveModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <span className="dialog-note">Note: It will Active or Inactive the Announcement & Notification.</span>
                </div>
            </Dialog>
        </>
    );
};
